<template>
  <div class="c-share">
    <c-action-sheet :visible.sync="visibleInline">
      <div slot="title">分享到</div>
      <div slot="menu">
        <div class="share-row">
          <div class="share-item" @click="shareTo(enumObj.wechat)">
            <i class="wechat-icon share-icon"></i>
            <span class="share-title">微信好友</span>
          </div>
          <div class="share-item" @click="shareTo(enumObj.wechatTimeline)">
            <i class="wechat-friends-icon share-icon"></i>
            <span class="share-title">朋友圈</span>
          </div>
        </div>
      </div>
      <div slot="action">
        <div class="weui-actionsheet__cell" @click="close">取消</div>
      </div>
    </c-action-sheet>
  </div>
</template>
<style lang="scss" scoped>
  @import './index.scss';
</style>
<script>
  export default {
    name: 'c-share',
    props: {
      config: {
        type: Object,
        default () {
          return {}
        }
      },
      visible: {
        type: Boolean,
        default: false
      }
    },
    data () {
      const enumObj = {
        wechat: 'wechat', // 微信分享
        wechatTimeline: 'circleFriends' // 微信朋友圈
      }
      return {
        enumObj,
        visibleInline: false
      }
    },
    components: {},
    created () {
      this.visibleInline = this.visible
    },
    mounted () {},
    beforeDestroy () {},
    methods: {
      shareTo (shareType) {
        window.$fe_bridge.shareAction[shareType](this.config, function () {
          console.log('have share')
        })
        setTimeout(() => {
          this.close()
        }, 330)
      },
      close () {
        this.visibleInline = false
      }
    },
    computed: {},
    watch: {
      visibleInline (val) {
        this.$emit('update:visible', val)
      },
      visible (val) {
        this.visibleInline = val
      }
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?1aa77920